import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="border-y border-slate-200 bg-white px-4 py-12 md:py-14" data-id="element-68" data-mp="2e067y48snqwi">
      <div className="mx-auto max-w-3xl" data-id="element-69" data-mp="2dy3iblbjzzsb">
        <Eyebrow data-id="element-70" data-mp="29139j2nbkixi">
          <span className="inline-flex items-center gap-2" data-id="element-71" data-mp="292o4gtdjq3vw">
            <HelpCircleIcon className="h-4 w-4" data-id="element-72" data-mp="241qqyu3hdy0q" /> Preguntas frecuentes
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-73" data-mp="1z3oxdf8figb0">
          Lo que más <span className="text-sky-600" data-id="element-74" data-mp="1z2njz43xxhq4">nos preguntan</span>
        </SectionTitle>
        <div className="mt-8 space-y-3" data-id="element-75" data-mp="so6387d6l9tv">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-sky-400 shadow-lg shadow-slate-200' : 'border-slate-200'}`} data-id="element-76" data-mp="nmyvu9eyacnq" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-5 text-left text-sm font-extrabold text-slate-900 md:text-base" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-77" data-mp="fjs2jba5xbt9">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sky-600 transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-78" data-mp="bioo8t7rjnu5" />
              </button>
              <AnimatePresence initial={false} data-id="element-79" data-mp="1teu77tczv3e">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-slate-200 px-5 py-4 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-80" data-mp="3jxq59m5dmhfn">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}